/* Insert the newsletter block into the middle of post content */
(function () {
    if (!document.body.classList.contains('post-template')) {
        return;
    }

    const content = document.querySelector('.post-template .gh-content');
    const newsletter = document.querySelector('[data-post-newsletter]');

    if (!content || !newsletter || content.contains(newsletter)) {
        return;
    }

    const topLevelParagraphs = Array.from(content.children).filter((element) => element.tagName === 'P');
    let insertionPoint = null;

    if (topLevelParagraphs.length > 0) {
        const insertionIndex = Math.min(6, Math.max(3, Math.floor(topLevelParagraphs.length / 2)));
        insertionPoint = topLevelParagraphs[Math.min(topLevelParagraphs.length - 1, insertionIndex)];
    } else if (content.children.length > 0) {
        insertionPoint = content.children[Math.floor(content.children.length / 2)];
    }

    if (insertionPoint) {
        insertionPoint.insertAdjacentElement('afterend', newsletter);
    }
})();
